/**
 * Task AA: Site settings fields of the redesigned home hero + /subscriptions page.
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  ["taa.site.headlineHint", "Breaks into lines after \"，\" / \"。\" / \". \"", "在“，”“。”或英文句点后自动换行"],
  ["taa.site.tagline", "Subscriptions page subline", "订阅页副标题"],
  ["taa.site.highlights", "Hero highlights (3)", "首屏亮点（3 项）"],
  ["taa.site.cards", "Feature cards (3)", "功能卡片（3 项）"],
  ["taa.site.steps", "Steps (4)", "步骤（4 步）"],
  ["taa.site.ctaTitle", "Closing band title", "底部号召标题"],
  ["taa.site.ctaSub", "Closing band text", "底部号召文字"],
] as const;

export type TaaKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TaaKey, string>;

export const taskAA = { en: col(1), zh: col(2), ms: col(1) };
